import { render, staticRenderFns } from "./GameBody.vue?vue&type=template&id=9df2733a&"
import script from "./GameBody.vue?vue&type=script&lang=ts&"
export * from "./GameBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports